import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    height: "100%",
    minHeight: 0,
  },

  searchBox: {
    marginTop: 16,
    marginBottom: 8,
    marginLeft: 24,
    marginRight: 24,
    backgroundColor: theme.palette.background200,
    borderRadius: theme.radius.radius300,
    "& .MuiOutlinedInput-root": {
      borderRadius: theme.radius.radius300,
      maxHeight: 52,
      backgroundColor: theme.palette.background200,
      "& fieldset": { border: "none" },
      "&:hover fieldset": { border: "none" },
      "&.Mui-focused fieldset": { border: "none" },
    },
  },

  listContainer: {
    flex: 1,
    minHeight: 0,
    width: "100%",
    backgroundColor: "transparent",
    borderRadius: 0,
    border: "none",
    overflow: "auto",
    ...theme.scrollbarStylesSoft,
  },

  listItem: {
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 24,
    paddingRight: 24,
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: theme.palette.background300,
    },
  },

  listItemSelected: {
    backgroundColor: theme.palette.background300,
  },

  primaryText: {
    color: theme.palette.neutral400,
    fontWeight: 500,
    fontSize: 14,
  },

  secondaryText: {
    color: theme.palette.neutral300,
    fontSize: 12,
  },

  footer: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    padding: 16,
  },

  btnFullWidth: {
    width: "100%",
  },

  buttonProgress: {
    marginLeft: 4,
  },

  emptyState: {
    color: theme.palette.neutral300,
    padding: 16,
    textAlign: "center",
  },

  loadingMore: {
    color: theme.palette.neutral300,
    padding: 12,
    textAlign: "center",
  },

  centeredState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    padding: 24,
    color: theme.palette.neutral300,
  },
  chipLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    whiteSpace: "nowrap",
  },
  chipSelecionado: {
    backgroundColor: theme.palette.background300,
    color: theme.palette.primary200,
    border: `1px solid ${theme.palette.primary100}`,
    "&:hover": {
      backgroundColor: theme.palette.background300,
      color: theme.palette.primary200,
    },
    "&:focus": {
      backgroundColor: theme.palette.background300,
      color: theme.palette.primary200,
    },
  },
  chipDefault: {
    backgroundColor: theme.palette.background200,
    color: theme.palette.neutral300,
    "&:hover": {
      backgroundColor: theme.palette.background200,
      color: theme.palette.neutral300,
    },
    "&:focus": {
      backgroundColor: theme.palette.background200,
      color: theme.palette.neutral300,
    },
  },
  chipContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: theme.espacamento.spacing200,
    overflowX: "auto",
    paddingLeft: theme.espacamento.spacing400,
    paddingRight: theme.espacamento.spacing400,
    marginBottom: "16px",
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": {
      height: 6,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent", 
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0.2)",
      borderRadius: 8,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "rgba(0,0,0,0.35)",
    },
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(0,0,0,0.2) transparent",
  },
}))

export default useStyles
